<div *ngIf="status === 'waiting'">
    Waiting for authentication from mobile app...
</div>

<div *ngIf="status === 'validating'">
    Validating sign in, please wait...
</div>

<div *ngIf="status === 'success'">
    Login successful. Redirecting...
</div>

<div *ngIf="status === 'error'" style="color: red;">
    Error: {{ errorMessage }}
</div>